import React from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '../hooks/useIsMobile';

interface SectionDividerProps {
  variant: 'wave' | 'gradient' | 'dots';
}

export const SectionDivider: React.FC<SectionDividerProps> = ({ variant }) => {
  const isMobile = useIsMobile();

  if (variant === 'wave') {
    return (
      <div className={`relative ${isMobile ? 'h-12' : 'h-24'} w-full overflow-hidden`}>
        <svg className="absolute bottom-0 w-full h-full" viewBox="0 0 1200 120" preserveAspectRatio="none">
          {isMobile ? (
            <path
              d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
              className="fill-gray-50 dark:fill-surface-900"
            />
          ) : (
            <motion.path
              d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
              className="fill-gray-50 dark:fill-surface-900"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 2, ease: "easeInOut" }}
            />
          )}
        </svg>
      </div>
    );
  }

  if (variant === 'gradient') {
    return (
      <div className={`${isMobile ? 'h-16' : 'h-32'} w-full bg-gradient-to-b from-transparent via-primary-500/5 to-transparent`} />
    );
  }

  // Dots variant — static on mobile, animated on desktop
  return (
    <div className={`${isMobile ? 'h-12' : 'h-24'} w-full flex items-center justify-center gap-2`}>
      {[...Array(3)].map((_, i) =>
        isMobile ? (
          <div
            key={i}
            className="w-1.5 h-1.5 rounded-full bg-gradient-to-r from-primary-500 to-accent-500 opacity-60"
          />
        ) : (
          <motion.div
            key={i}
            className="w-2 h-2 rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
            animate={{
              scale: [1, 1.5, 1],
              opacity: [0.5, 1, 0.5]
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              delay: i * 0.2
            }}
          />
        )
      )}
    </div>
  );
};
